<template>
  <div class="history">
    <div class="top">
      <div class="headline">
        <span>Invoice overview</span>
        <span class="loading">{{ loading }}</span>
      </div>
    </div>
    <div v-if="showHistory" class="current-plan">
      <div class="title">Current plan</div>
      <div class="type">{{ subscriptionType.name }}</div>
      <div class="interval">
        {{ calcTotal.toFixed(2) }} € per
        {{ subscriptionType.interval.toLowerCase() }}
      </div>
      <div class="charged">
        <span v-if="this.$store.state.subscription.active === 1 && this.$store.state.subscription.subscription_payment_type_id !== 4">Your plan will be automatically renewed on {{ subscriptionExtendedOn }}</span>
        <span v-if="this.$store.state.subscription.active === 1 && this.$store.state.subscription.subscription_payment_type_id === 4">Your plan will automatically expire on {{ subscriptionExtendedOn }}</span>
        <span v-if="this.$store.state.subscription.active === 0">Your plan is cancelled</span>
      </div>
    </div>
    <div v-if="showHistory" class="history-container">
      <div class="title">Invoice history</div>
      <div class="email-hint">
        Please enter an e-mail address to the one you want to send the invoice
        to when you press the "send invoice" button.
      </div>
      <div class="email">
        <input
          v-model="email"
          class="input"
          type="email"
          placeholder="E-mail"
        />
      </div>
      <div class="history-item-container">
        <div
          v-for="(value, key) in subscriptionHistory"
          v-bind:key="key"
          v-bind:value="value.invoice_id"
          class="history-item"
        >
          <div class="invoice-id">{{ value.invoice_id }}</div>
          <div v-on:click="getInvoice(value.invoice_id)" class="invoice">
            <font-awesome-icon icon="file-invoice" />
          </div>
          <div class="charged">{{ value.created_at }}</div>
          <div class="price">{{ (value.price / 100).toFixed(2) }} €</div>
          <div class="type">{{ value.name }}</div>
          <div v-on:click="sendInvoice(value.invoice_id)" class="send">
            <span>send invoice</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "history-view",
  data() {
    return {
      title: "Invoice overview",
      showHistory: false,
      email: "",
      loading: "",
      loadingTimeout: null,
      cancelTokens: {
        getCountries: axios.CancelToken.source(),
        getSubscriptionCustomer: axios.CancelToken.source(),
        getSubscription: axios.CancelToken.source(),
        getSubscriptionHistory: axios.CancelToken.source(),
      },
    };
  },
  props: {},
  components: {},
  computed: {
    subscriptionExtendedOn() {
      let nextCharge = "";
      switch (this.subscriptionType.interval) {
        case "MONTH":
          break;
        case "YEAR":
          nextCharge +=
            parseInt(this.$store.state.subscription.charged_at.split("-")[0]) +
            1;
          nextCharge += "-";
          nextCharge += this.$store.state.subscription.charged_at.split("-")[1];
          nextCharge += "-";
          nextCharge += this.$store.state.subscription.charged_at.split("-")[2];
          break;
      }
      return nextCharge;
    },
    subscriptionHistory() {
      return this.$store.state.subscriptionHistory;
    },
    subscriptionType() {
      return this.$store.state.subscriptionType;
    },
    subscriptionTypeLoaded() {
      return this.$store.state.subscriptionTypeLoaded;
    },
    calcPrice() {
      return this.subscriptionType.price / 100;
    },
    calcTax() {
      if (
        this.getCountryWithId(this.$store.state.customerData.country) != null
      ) {
        if (
          this.getCountryWithId(this.$store.state.customerData.country).tax !=
          null
        ) {
          if (
            this.$store.state.customerData.vatId != null &&
            this.$store.state.customerData.vatId != ""
          ) {
            return 0;
          }
          return (
            (this.calcPrice *
              this.getCountryWithId(this.$store.state.customerData.country)
                .tax) /
            100
          );
        }
      }
      return 0;
    },
    calcTotal() {
      let total = this.subscriptionType.price / 100 + this.calcTax;
      this.$store.commit("assignPriceWithTax", total * 100);
      return total;
    },
    tax() {
      if (
        this.getCountryWithId(this.$store.state.customerData.country) != null
      ) {
        if (
          this.getCountryWithId(this.$store.state.customerData.country).tax !=
          null
        ) {
          if (this.calcTax == 0) {
            return 0;
          } else {
            return this.getCountryWithId(this.$store.state.customerData.country)
              .tax;
          }
        }
      }
      return false;
    },
  },
  methods: {
    async sendInvoice(invoice_id) {
      if (this.email != "") {
        if (
          confirm(
            "Are you sure you want to send the invoice " +
              invoice_id +
              " to the email address " +
              this.email +
              "?"
          )
        ) {
          await this.$store.dispatch("sendInvoice", {
            invoice_id: invoice_id,
            email: this.email,
          });
        } else {
          await this.$store.dispatch("changeErrorMsg", {
            msg: "Sending the invoice was aborted.",
            type: "negativ",
          });
        }
      } else {
        await this.$store.dispatch("changeErrorMsg", {
          msg: "Please fill out the email input.",
          type: "negativ",
        });
      }
    },
    getCountryWithId(countryId) {
      for (let i = 0; i < this.$store.state.countries.length; i++) {
        if (this.$store.state.countries[i].id == countryId) {
          return this.$store.state.countries[i];
        }
      }
      return null;
    },
    async getInvoice(invoiceId) {
      await this.$store.dispatch("getInvoice", invoiceId);
    },
    stopLoading() {
      clearInterval(this.loadingTimeout);
      this.loading = "";
    },
    createLoading() {
      var thisGlobal = this;
      this.loadingTimeout = window.setInterval(function() {
        if (thisGlobal.loading == "...") {
          thisGlobal.loading = "";
        } else {
          thisGlobal.loading += ".";
        }
      }, 500);
    },
  },
  async mounted() {
    this.createLoading();
    await this.$store.dispatch("getCountries", this.cancelTokens.getCountries);
    await this.$store.dispatch(
      "getSubscriptionCustomer",
      this.cancelTokens.getSubscriptionCustomer
    );
    await this.$store.dispatch(
      "getSubscription",
      this.cancelTokens.getSubscription
    );
    await this.$store.dispatch(
      "getSubscriptionType",
      this.$store.state.subscription.subscription_type_id
    );
    await this.$store.dispatch(
      "getSubscriptionHistory",
      this.cancelTokens.getSubscriptionHistory
    );
    this.showHistory = true;
    this.stopLoading();
  },
  beforeDestroy() {
    this.cancelTokens.getCountries.cancel("View closed");
    this.cancelTokens.getSubscriptionCustomer.cancel("View closed");
    this.cancelTokens.getSubscription.cancel("View closed");
    this.cancelTokens.getSubscriptionHistory.cancel("View closed");
  },
};
</script>

<style scoped>
.history {
  width: 100%;
  height: 100%;
  display: flex;
  padding-left: 60px;
  padding-right: 60px;
  flex-direction: column;
}

.top .headline {
  font-size: 30px;
}

.top {
  height: 100px;
  display: flex;
  align-items: center;
}
.current-plan {
  width: 100%;
  margin-bottom: 50px;
  display: flex;
  flex-direction: column;
}

.current-plan .type {
  font-size: 20px;
  margin-bottom: 10px;
}
.current-plan .interval {
  font-size: 16px;
  margin-bottom: 3px;
}
.current-plan .charged {
  font-size: 14px;
}
.current-plan .title {
  border-bottom: 1px solid #e7e7e7;
  display: flex;
  width: 100%;
  height: 30px;
  margin-bottom: 30px;
}
.history-container {
  width: 100%;
  height: 47%;
  display: flex;
  flex-direction: column;
}
.history-container .title {
  border-bottom: 1px solid #e7e7e7;
  display: flex;
  width: 100%;
  height: 30px;
  margin-bottom: 30px;
}

.history-item {
  display: flex;
  margin-bottom: 30px;
  align-items: center;
}
.history-item .invoice-id {
  margin-right: 10px;
  font-weight: bold;
}
.history-item .charged {
  margin-right: 10px;
  margin-left: 80px;
}
.history-item .price {
  margin-right: 10px;
  width: 200px;
  display: flex;
  justify-content: center;
}
.history-item .invoice {
  cursor: pointer;
}
.history-item-container {
  height: 100%;
  overflow-y: auto;
}
.send span {
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
  background-color: #ffc20f;
  color: white;
  border-radius: 3px;
}
.send {
  height: 30px;
  width: 150px;
  margin-left: 80px;
  display: flex;
  cursor: pointer;
}

.email input {
  height: 100%;
  width: 100%;
}

.email {
  height: 30px;
  width: 300px;
  margin-top: 10px;
  margin-bottom: 30px;
}
</style>
